<template lang="pug">
.briq-form-element
  label {{ label }}
  briq-required-and-optional-markers(:isRequired="this.$attrs.required" :isDisabled="this.$attrs.disabled || this.$attrs.readonly" :hideOptionalMarker="hideOptionalMarker" :label="label")
  briq-tooltip(:help="help")
  .image-upload
    div(v-show="hasImage" data-test-id="image-preview")
      img.preview(ref="preview" :src="imageSource")
    input(ref="upload" type="file" @change="fileChosen" hidden)
    .buttons
      BriqButton(v-show="!hasImage" @click="choose" small :disabled="disabled") Choose image
      BriqButton(v-show="hasImage" @click="choose" small :disabled="disabled") Change image
      BriqButton(v-show="hasImage" @click="remove" small :disabled="disabled" variant="secondary") Delete image
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  props: {
    label: String,
    value: String,
    disabled: Boolean,
    help: String,
    isSecondary: {
      type: Boolean,
      default: false,
    },
    hideOptionalMarker: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageSource: this.value || null,
      width: 0,
      height: 0,
    }
  },
  computed: {
    ...mapState('imagePicker', ['file', 'fileTwo']),
    hasImage() {
      const hasFile = this.isSecondary ? this.fileTwo : this.file
      return hasFile || this.value
    },
  },
  methods: {
    ...mapMutations('imagePicker', [
      'setFile',
      'removeExistingFile',
      'setFileTwo',
      'removeExistingFileTwo',
    ]),
    choose() {
      this.$refs.upload.click()
    },
    remove() {
      this.$refs.upload.value = ''
      this.imageSource = null
      const removeExistingFile = this.isSecondary
        ? this.removeExistingFileTwo
        : this.removeExistingFile
      const setFile = this.isSecondary ? this.setFileTwo : this.setFile
      removeExistingFile(!!this.value)
      setFile(null)
    },
    fileChosen(e) {
      const files = e.target.files
      if (files && files[0]) {
        const file = files[0]
        const fileType = file.type
        if (fileType.startsWith('image')) this.handleChoseImage(file)
        else this.$logError('user did not select an image')
      } else this.$logError('could not read from files:', e.target.files) // todo: notification?
    },
    handleChoseImage(file) {
      const removeExistingFile = this.isSecondary
        ? this.removeExistingFileTwo
        : this.removeExistingFile
      const setFile = this.isSecondary ? this.setFileTwo : this.setFile
      removeExistingFile(!!this.value)
      setFile(file)
      this.setImageForPreview(file)
    },
    setImageForPreview(file) {
      const reader = new FileReader()
      const preview = this.$refs.preview
      reader.onload = e => {
        this.imageSource = e.target.result
      }
      reader.readAsDataURL(file)
    },
  },
  mounted() {
    if (this.file) this.setImageForPreview(this.file)
    else if (this.fileTwo) this.setImageForPreview(this.fileTwo)
  },
}
</script>

<style scoped lang="stylus">
.image-upload
  border-radius 2px
  background-color #f1f3f6
  border solid 1px #ebebeb
  padding 10px
  width 100%
  min-height 156px
  display flex
  align-items center
  justify-content center

.preview
  max-height 128px
  max-width 240px
  margin-bottom 5px

.dimensions
  margin-bottom 5px

  span
    margin 0 5px

.buttons
  display flex
  flex-direction column
  justify-content center

  button
    margin 5px 10px
</style>
